import script from "./TicketPresentationCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketPresentationCard.vue?vue&type=script&lang=ts&setup=true"

import "./TicketPresentationCard.vue?vue&type=style&index=0&id=792bb6de&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792bb6de"]])

export default __exports__